export const FULFILL_INVESTORS = 'investors.FULFILL';
export const SAVE_INVESTOR = 'investors.SAVE';
export const DELETE_INVESTOR = 'investors.DELETE';
